import Axios from 'axios';

// TODO put to separate config file
const WebService = Axios.create({
    baseURL : "https://administrator-backend.nostratech.com/api/v1",
    headers: {'Authorization': localStorage.getItem('token')}
});

export default WebService;
